export type IconVisualType =
  | "danger"
  | "default"
  | "info"
  | "success"
  | "warning";
